import { lazy } from 'react'
import generateRouterDetail from 'utils/helpers/generateRouterDetail'
import { abAdminRBAC } from '../pages/ABAdmin/rbac'
import { abAdminUserListRBAC } from '../pages/ABAdminUserList/rbac'

type NamedRoutesType =
  | 'ABAdminLoginRouter'
  | 'ABAdminNonLoginRouter'
  | 'ABAdminAddEditRouter'
  | 'ABAdminUserListRouter'

type PathListsType =
  | '/dashboard/ab-admin'
  | '/dashboard/ab-admin-non-login'
  | '/dashboard/ab-admin/:experimentId'
  | '/dashboard/ab-admin-user-list'

type RouterInstanceType = RouterFeatureInterface<NamedRoutesType, PathListsType>

const ABAdminPage = lazy(() => import('pages/ABAdmin/GetList'))
const ABAdminAddEditPage = lazy(() => import('pages/ABAdmin/ABAdminCreateEdit'))
const ABAdminUserListPage = lazy(() => import('features/ABAdmin/pages/ABAdminUserList'))

export const ABAdminLoginRouter: RouterInstanceType = {
  name: 'ABAdminLoginRouter',
  Component: ABAdminPage,
  path: '/dashboard/ab-admin',
  routeType: 'PRIVATE',
  rbacPageID: abAdminRBAC.pageID,
  allowedRoles: [],
  isDashboard: true,
}

const ABAdminNonLoginRouter: RouterInstanceType = {
  name: 'ABAdminNonLoginRouter',
  Component: ABAdminPage,
  path: '/dashboard/ab-admin-non-login',
  routeType: 'PRIVATE',
  rbacPageID: abAdminRBAC.pageID,
  allowedRoles: [],
  isDashboard: true,
}

const ABAdminAddEditRouter: RouterInstanceType = {
  name: 'ABAdminAddEditRouter',
  Component: ABAdminAddEditPage,
  path: '/dashboard/ab-admin/:experimentId',
  routeType: 'PRIVATE',
  rbacPageID: abAdminRBAC.pageID,
  allowedRoles: [],
  isDashboard: true,
}

export const ABAdminUserListRouter: RouterInstanceType = {
  name: 'ABAdminUserListRouter',
  Component: ABAdminUserListPage,
  path: '/dashboard/ab-admin-user-list',
  routeType: 'PRIVATE',
  rbacPageID: abAdminUserListRBAC.pageID,
  allowedRoles: [],
  isDashboard: true,
}

const ABAdminRouter: RouterInstanceType[] = [
  ABAdminLoginRouter,
  ABAdminNonLoginRouter,
  ABAdminAddEditRouter,
  ABAdminUserListRouter,
]

export const ABAdminRouterDetail = generateRouterDetail(ABAdminRouter)

export default ABAdminRouter
